import styled from 'styled-components';

export const StyledSelect = styled.select`
  font-family: var(--prs-ff-sans);
`;
